import React, { useEffect } from 'react';
import ReactMarkdown, { Components } from 'react-markdown';
import remarkDirective from 'remark-directive'
import remarkDirectiveSugar from 'remark-directive-sugar'
import GithubSlugger from 'github-slugger'
import { createElement } from 'react'
import { ExtraProps } from 'react-markdown'

const MarkdownHeading = ({ children, level }: (React.ClassAttributes<HTMLHeadingElement> & React.HTMLAttributes<HTMLHeadingElement> & ExtraProps & { level: number })) => {
    const value = extractString(children)

    const slugger = new GithubSlugger()
    const slug = slugger.slug(value)

    return createElement(
        `h${level}`,
        { id: slug },
        <>
            {children}
        </>
    )
}

const MarkdownHeading1 = (props: (React.ClassAttributes<HTMLHeadingElement> & React.HTMLAttributes<HTMLHeadingElement> & ExtraProps)) => {
    return MarkdownHeading({ level: 1, ...props });
}
const MarkdownHeading2 = (props: (React.ClassAttributes<HTMLHeadingElement> & React.HTMLAttributes<HTMLHeadingElement> & ExtraProps)) => {
    return MarkdownHeading({ level: 2, ...props });
}
const MarkdownHeading3 = (props: (React.ClassAttributes<HTMLHeadingElement> & React.HTMLAttributes<HTMLHeadingElement> & ExtraProps)) => {
    return MarkdownHeading({ level: 3, ...props });
}
const MarkdownHeading4 = (props: (React.ClassAttributes<HTMLHeadingElement> & React.HTMLAttributes<HTMLHeadingElement> & ExtraProps)) => {
    return MarkdownHeading({ level: 4, ...props });
}

const extractString = (obj: string | any | any[]): string => {
    if (typeof obj === 'string') return obj;
    else if (obj?.props?.children) {
        if (Array.isArray(obj.props.children)) {
            return obj.props.children
                .map((child: any) => extractString(child))
                .join('');
        }
        return extractString(obj.props.children);
    } else return '';
};

const Markdown: React.FC<{ content?: string }> = ({ content }) => {

    const components: Components = {
        h1: MarkdownHeading1,
        h2: MarkdownHeading2,
        h3: MarkdownHeading3,
        h4: MarkdownHeading4,
    }

    useEffect(() => {
        let url = window.location.hash;
        let target = url.substring(1).toLowerCase();
        let element = document.getElementById(target);
        element && element.scrollIntoView({ behavior: "smooth", block: "start" });
    }, [content]);

    return (
        <ReactMarkdown components={components} remarkPlugins={[remarkDirective, [remarkDirectiveSugar, { video: { iframeProps: { 'allowfullscreen': 'allowfullscreen' } } }]]}>
            {content}
        </ReactMarkdown>
    )
};

export default Markdown;